import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { Form, Input, Button, Divider } from 'antd';
import { PublicationRecognitionItem } from 'types/newUniprofile';
import s from './s.module.less';
import { isEqual } from 'lodash';

interface Props {
    initValue?: PublicationRecognitionItem[];
    isEditing?: boolean;
}

const Publications = forwardRef((props: Props, ref) => {
    const { isEditing, initValue } = props;
    const [form] = Form.useForm<{ publicationsList: PublicationRecognitionItem[] }>();
    const prevInitValueRef = useRef<PublicationRecognitionItem[]>();

    useEffect(() => {
        // 只有当initValue内容真正发生变化时才更新表单
        if (initValue?.length && !isEqual(prevInitValueRef.current, initValue)) {
            form.setFieldsValue({
                publicationsList: initValue,
            });
            prevInitValueRef.current = initValue;
        }
    }, [initValue]);

    const getValues = async () => {
        const values = await form.validateFields();
        return values.publicationsList;
    };

    useImperativeHandle(ref, () => ({
        getValues,
    }));

    const renderEditing = () => {
        return (
            <Form
                form={form}
                autoComplete="off"
                layout="vertical"
                scrollToFirstError
            >
                <Form.List name="publicationsList">
                    {
                        (fields, { add, remove }) => {
                            return (
                                <div className={s.wrap}>
                                    <div className={s.label}>Publications or additional resources</div>
                                    <Divider style={{ margin: '4px 0px 12px' }} />
                                    {
                                        fields.map(({ key, name, ...restField }, index) => {
                                            return (
                                                <div key={key} className={s.card}>
                                                    <div className={s.label}>{`Publication ${index + 1}`}</div>
                                                    <Divider style={{ margin: '4px 0px 12px' }} />
                                                    <div
                                                        id={`Publication/resource_${index + 1}`}
                                                    />
                                                    <Form.Item
                                                        {...restField}
                                                        label="Article/publication name"
                                                        name={[name, 'name']}
                                                    >
                                                        <Input type="text" />
                                                    </Form.Item>
                                                    <Form.Item
                                                        {...restField}
                                                        label="Authors"
                                                        name={[name, 'authors']}
                                                    >
                                                        <Input type="text" />
                                                    </Form.Item>
                                                    <Form.Item
                                                        {...restField}
                                                        label="Website"
                                                        name={[name, 'website']}
                                                    >
                                                        <Input type="text" />
                                                    </Form.Item>
                                                    <div className={s.formFooter}>
                                                        <Button onClick={() => remove(index)}>Remove</Button>
                                                    </div>
                                                </div>

                                            );
                                        })
                                    }
                                    <div
                                        onClick={() => add()}
                                        className={s.add}
                                    >
                                        + Add another publication
                                    </div>
                                </div>
                            );
                        }
                    }
                </Form.List>
            </Form>

        );
    };

    const renderReview = () => {
        if (!initValue?.length) {
            return (
                <>
                    <div className={s.label}>Publications or additional resources</div>
                    <div className="mt-2">
                        Not provided
                    </div>
                </>
            );
        }
        return (
            <>
                <div className={s.label}>Publications or additional resources</div>
                <ul className="list-disc ml-4 mt-2">
                    {initValue?.map((item, index) => {
                        return (
                            <li key={index}>
                                {item.name}
                                <div>{item.authors}</div>
                                <a href={item.website} target="_blank" rel="noreferrer">{item.website}</a>
                            </li>
                        );
                    })}
                </ul>
            </>
        );
    };

    return (
        <div>
            {isEditing ? renderEditing() : renderReview()}
        </div>
    );
});

export default Publications;
